/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartLocker',[
    'jquery',
    'lodash',
    'global/all',
    './CartManager'
], function ($, _, Roc, CartManager) {
    'use strict';

    var cartLockCheckedCookieName = "user_cart_lock_checked";
    var cartLockedCookieName = "user_cart_locked";

    function isCartLocked() {
        var deferred = $.Deferred();
        getCartLock()
            .then(function (isCartLocked) {
                if (isCartLocked) {
                    Roc.UI.confirm({
                        "title": 'Locked Cart',
                        "message":
                            'Your cart is locked. Would you like to replace all items currently in your cart with item(s) that you are adding?',
                        "buttons": {
                            "Continue": {
                                "class": 'btn btnAction confirm unlockCartButton',
                                "autoClose": false,
                                "action": function () {
                                    Roc.Core.lockButton('.unlockCartButton');
                                    removeCurrentCart()
                                        .then(
                                            function () {
                                                unlockCart();
                                                deferred.resolve();
                                                $('.closeCartLockerModal').trigger('click');
                                            },
                                            function () {
                                                deferred.reject();
                                            });
                                }
                            },
                            "Cancel": {
                                "class": 'btn closeCartLockerModal',
                                "action": function() {
                                    deferred.reject();
                                }
                            }
                        }
                    });
                    
                } else {
                    deferred.resolve();
                }
            });
        return deferred;
    }

    function getCartLock() {
        //do we know if cart is locked or unlocked?
        if (Roc.Core.getCookie(cartLockCheckedCookieName)) {
                return $.Deferred()
                    .resolve(!!Roc.Core.getCookie(cartLockedCookieName))
                    .promise();
        } else {
            return queryCartLock().then(function (locked) {
                //cart was already locked/unlocked in event handler
                return locked;
            });
        }
    }

    function queryCartLock() {
        var forceRecalculate = false;

        var request = {
            orderId: '{orderId}',
            forceRecalculate: forceRecalculate
        };

        return $.proxyRequest({
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: '/api/store/cart/',
            data: JSON.stringify(request)
        }).then(function(orderCart) {
            Roc.Logger.info(orderCart);
            Roc.Logger.info('CartLocker -> getCurrentCart');
            Roc.EventManager.notify(Roc.Events.cart.GET_CURRENT_CART, orderCart);
            return !!orderCart.customFields && !!orderCart.customFields.quoteId;
        });
    }

    function removeCurrentCart() {
        return $.ajax({
            url: '/ajax/ClearCurrentCart',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json'
        });
    }

    function lockCart() {
        Roc.Logger.info('CartLocker -> lockCart: saving cart lock checked cookie...');
        Roc.Core.createCookie(cartLockCheckedCookieName, true, /*days*/30);
        Roc.Logger.info('CartLocker -> lockCart: saving cart locked cookie...');
        Roc.Core.createCookie(cartLockedCookieName, true, /*days*/30);
    }

    function unlockCart() {
        Roc.Logger.info('CartLocker -> unlockCart: saving cart lock checked cookie...');
        Roc.Core.createCookie(cartLockCheckedCookieName, true, /*days*/30);
        Roc.Logger.info('CartLocker -> unlockCart: removing cart locked cookie...');
        Roc.Core.eraseCookie(cartLockedCookieName);
    }

    function clearLock() {
        Roc.Logger.info('CartLocker -> clearLock: removing cart lock checked cookie...');
        Roc.Core.eraseCookie(cartLockCheckedCookieName);
        Roc.Logger.info('CartLocker -> clearLock: removing cart locked cookie...');
        Roc.Core.eraseCookie(cartLockedCookieName);
    }

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.users.LOGIN, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success &&
                response.currentOrder &&
                response.currentOrder.customFields &&
                response.currentOrder.customFields.quoteId) {
                lockCart();
            } else {
                unlockCart();
            }
        });
        Roc.EventManager.bind(Roc.Events.users.LOGOUT, function (xhr) {
            clearLock();
        });

        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART,
            function (currentCart) {
                if (currentCart.customFields && currentCart.customFields.quoteId) {
                    lockCart();
                } else {
                    unlockCart();
                }
            });
        Roc.EventManager.bind(Roc.Events.cart.PAGE_LOAD,
            function (currentCart) {
                if (currentCart.customFields && currentCart.customFields.quoteId) {
                    lockCart();
                } else {
                    unlockCart();
                }
            });
    };

    function init() {
        bindEvents();
    };

    var CartLocker = {
        init: init,
        isCartLocked: isCartLocked,
        lockCart: lockCart
    };

    Roc.Logger.debug('CartLocker.js Loaded:', CartLocker);

    return CartLocker;
});

